import { useProviderPanels } from "../contexts/provider-panels-context";
import useViewPreferencesPreloader from "app/provider-panel/hooks/useViewPreferencesPreloader";

const useComponentInitializer = () => {
  const preloadViewPreferences = useViewPreferencesPreloader();
  const {initializeComponent} = useProviderPanels();

  return async () => {
    const {filters, pageParams} = await preloadViewPreferences();

    initializeComponent({filters, pageParams});
  };
};

export default useComponentInitializer;
